export const currentWork = {
  // 最近一次加载出来的work：当前work 
	state: {
    currentWork: null,
	},
	mutations: {
    setCurrentWork (state, work) {
      if (typeof work === 'object') {
        state.currentWork = work
      } else {
        throw new TypeError('the work is not a object [vuex]')
      }
    },
	},
	actions: {
    
	},
	getters: {
    work: state => state.currentWork,
	}
}




// WEBPACK FOOTER //
// ./src/store/modules/current-work/index.js